/** Encerra o splash HTML de `public/index.html` quando o React assume o loading. */
export const dismissHtmlSplash = () => {
  if (typeof window.finishProgress === 'function') {
    window.finishProgress();
  }
};
